import { useEffect } from 'react'
import { SITE_URL } from '@/lib/useDocumentMeta'

/**
 * Site-wide Organization JSON-LD (Phase 7 — "JSON-LD site-wide", previously
 * only BlogArticlePage had schema, per-post). Mounted once in App.tsx,
 * outside the lang-specific routes, since the business itself doesn't
 * change between languages. Real facts only: name/founder/location from
 * about/index.tsx's real copy, phone number from lib/contact.ts (WhatsApp
 * number, reformatted to E.164 with a leading +).
 */
export function OrganizationSchema() {
  useEffect(() => {
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'ProfessionalService',
      name: 'EA Studio',
      url: SITE_URL,
      image: `${SITE_URL}/og-image.webp`,
      logo: `${SITE_URL}/favicon-32x32.png`,
      telephone: '+38761722891',
      founder: { '@type': 'Person', name: 'Ermin Avdibašić' },
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Kalesija',
        addressRegion: 'Kanton Tuzla',
        addressCountry: 'BA',
      },
      areaServed: 'BA',
      sameAs: [
        'https://www.facebook.com/profile.php?id=61591545871243',
        'https://www.instagram.com/ea.studio.official/',
      ],
    })
    document.head.appendChild(script)
    return () => {
      script.remove()
    }
  }, [])

  return null
}
